import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"

const renderPlatformButton = (platform) => {
  return (
    <a
      key={platform._id}
      href={platform.link && platform.link[0].url}
      target="_blank"
      rel="noreferrer"
      className="w-[190px] h-[55px] flex items-center p-0 hover:opacity-90 transition-opacity"
    >
      <img
        src={platform.image}
        alt={platform.name}
        className="w-full h-full object-cover"
      />
    </a>
  )
}

const TTFooterBanner = () => {
  return (
      <CMSRender
        contentType="T&TFooterCTA"
        renderItem={(data, id) => {
          return (
            <div className="relative w-full bg-gradient_tt_bottom_banner px-[22px] md:px-px1_l xl:px-px1_xl pt-[30px] md:pt-[62px] lg:pt-[109px] pb-[24px] md:pb-[65px] lg:pb-[96px] overflow-hidden rounded-[50px] md:rounded-[100px]">
              {/* White Container + Rating Section */}
              <div 
                className="relative max-w-w2_xl mx-auto"     style={{ zIndex: 10 }}
              >
                {/* White Card Container */}
                <div 
                  className="bg-paper rounded-[50px] md:rounded-[56px] lg:rounded-[70px] pt-[30px] md:pt-px1_xl lg:pt-[109px] pb-[50px] md:pb-[90px] text-center mb-6 md:mb-[76px] lg:mb-[64px]"
                  
                >
                  {/* App Icon */}
                  <div className="w-[80px] md:w-[120px] h-[80px] md:h-[120px] rounded-[30px] overflow-hidden scale-100 mx-auto mb-2 md:mb-[35px]">
                    <img
                      src={data.app_icon}
                      alt="Talk & Translate"
                      className="w-full h-full object-contain"
                      imageRendering="crisp-edges"
                    />
                  </div>

                  {/* Title & Subtitle */}
                  <Typography
                    component="h2" 
                    variant="h1"
                    className="w-[90%] text-text text-center mb-6 mx-auto">
                    {data.title}
                  </Typography>

                  <Typography
                    variant="body1"
                    className="mb-6 md:mb-[46px]"
                  >
                    {data.subtitle}
                  </Typography>

                  {/* Store Buttons */}
                  <div className="flex flex-col md:flex-row items-center justify-center gap-[16px]">
                    {data.store_buttons.map(renderPlatformButton)}
                  </div>
                </div>

                {/* Rating Section */}
                <div className="text-center  text-white ">
                  <div className="flex justify-center mb-[10px] lg:mb-4">
                    {[...Array(5)].map((_, i) => (
                      <svg
                        key={i}
                        className="w-5 h-5 text-yellow-400 fill-current"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" />
                      </svg>
                    ))}
                  </div>

                  <Typography
                    variant="body1"
                    className="text-white max-w-[224px] md:max-w-full mx-auto my-0"
                  >
                    {data.rating_text}
                  </Typography>
                </div>
              </div>
              
              {/* Radial Background in Blue Container */}
              <div className="absolute w-full h-full top-0 left-0">
                <img
                  src={data.background}
                  className="h-full object-cover"
                />
              </div>
            </div>
          )
        }}
      />

      
  )
}

export default TTFooterBanner
